import main from '@/views/main.vue' //主视图
import login from '@/views/login.vue' //登录页
// import home from '@/views/pages/home/home.vue'  //首页--舆情概要
// import groupSpec from '@/views/pages/groupSpec/groupSpec.vue' //群组监测
// import groupSpec_group from '@/views/pages/groupSpec/groupSpec_group.vue'  //群组监测--查看群消息
// import mediaSpec from '@/views/pages/mediaSpec/mediaSpec.vue'  //媒体监测
// import mediaSpec_similarArticle from '@/views/pages/mediaSpec/mediaSpec_similarArticle.vue' //媒体监测--相似文章
// import specConfig from '@/views/pages/specConfig/specConfig.vue'  //监测配置
// import report from '@/views/pages/report/report.vue'  //分析报告
// import warningList from '@/views/pages/warningList/warningList.vue' //预警列表

export default [
  {
    path: '/',
    name: 'login',
    component: login,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/main',
    name: 'main',
    redirect: '/home',
    component: main,
    children: [
      //舆情概要
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/pages/home/home.vue'),
        meta: {
          title: '舆情概要'
        }
      },
      //群组监测
      {
        path: '/groupSpec',
        name: 'groupSpec',
        component: () => import('@/views/pages/groupSpec/groupSpec.vue'),
        meta: {
          title: '群组监测'
        }
      },
      //群组监测--查看群发言
      {
        path: '/groupSpec_group',
        name: 'groupSpec_group',
        component: () => import('@/views/pages/groupSpec/groupSpec_group.vue'),
        meta: {
          title: '群成员发言记录'
        }
      },
      //媒体监测
      {
        path: '/mediaSpec',
        name: 'mediaSpec',
        component: () => import('@/views/pages/mediaSpec/mediaSpec.vue'),
        meta: {
          title: '媒体监测'
        }
      },
      //媒体监测--相似文章
      {
        path: '/mediaSpec_similarArticle',
        name: 'mediaSpec_similarArticle',
        component: () => import('@/views/pages/mediaSpec/mediaSpec_similarArticle.vue'),
        meta: {
          title: '相似文章'
        }
      },
      //分析报告
      {
        path: '/report',
        name: 'report',
        component: () => import('@/views/pages/report/report.vue'),
        meta: {
          title: '分析报告'
        }
      },
      //监测配置
      {
        path: '/specConfig',
        name: 'specConfig',
        component: () => import('@/views/pages/specConfig/specConfig.vue'),
        meta: {
          title: '监测配置'
        }
      },
      //预警列表
      {
        path: '/warningList',
        name: 'warningList',
        component: () => import('@/views/pages/warningList/warningList.vue'),
        meta: {
          title: '预警列表'
        }
      },
      //全局搜索结果页
      {
        path: '/searchGlobal',
        name: 'searchGlobal',
        component: () => import('@/views/pages/searchGlobal/searchGlobal.vue'),
        meta: {
          title: '搜索结果'
        }
      },
      //个人中心
      {
        path: '/personal',
        name: 'personal',
        component: () => import('@/views/pages/personal/personal.vue')
      },
        // 重点关注
      {
        path: '/focus',
        name: 'focus',
        component: () => import('@/views/pages/focus/focus.vue')
      },
        // 重点事件
      {
        path: '/event',
        name: 'event',
        component: () => import('@/views/pages/event/event.vue')
      },
      {
        path: '/eventReport',
        name: 'eventReport',
        component: () => import('@/views/pages/event/eventReport.vue'),
      }
    ]
  },
  //沙盒/小流量/全流量设置
  {
    path: '/staff',
    name: 'staff',
    component: () => import('@/views/pages/staff/staff.vue')
  },
  {
    path: '*',
    redirect: '/home'
  }
]


